export default "__VITE_ASSET__BBJ9A52y__ 224w, __VITE_ASSET__lVwRZpw3__ 448w";